import TextEditorCustomize from '@/components/TextEditorCustomize'
import useAuthStore from '@/stores/useAuthStore'
import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

interface Props {
    control: Control<any>
    viewOnly?: boolean
    maxHeight?: boolean
    ticket?: any
}

const TicketContent: React.FC<Props> = ({
    control,
    viewOnly = false,
    maxHeight,
    ticket,
}) => {
    const { t } = useTranslation()
    const { employee } = useAuthStore()

    const employeeName = ticket?.employee_name || employee?.employee_name
    return (
        <div className={`${maxHeight ? 'h-full flex flex-col' : 'mt-4'}`}>
            <Typogaphy size="small" className="mb-1">
                {t('ticket-description')} *
            </Typogaphy>

            <Controller
                control={control}
                name="ticket_content"
                render={({ field }) => (
                    <TextEditorCustomize
                        disabled={viewOnly}
                        disabledAttachments={false}
                        value={
                            typeof field.value === 'string'
                                ? { text: field.value, attachments: [] }
                                : field.value || { text: '', attachments: [] }
                        }
                        onChange={(val) => field.onChange(val)}
                        imagePrefix="tickets"
                        attachmentPrefix="tickets"
                    />
                )}
            />

            <div className="flex items-center justify-end mt-2">
                <div className="flex gap-2 items-center">
                    <p className="text-xs font-medium">From</p>
                    <div className="bg-[#ECF4FF] px-4 py-2 rounded-[4px]">
                        <p className="text-xs font-normal">
                            {t('ticket-creator')}
                            <span className="font-medium">
                                {' '}
                                [ {employeeName} ]
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TicketContent
